import { PromotersModule } from '@/modules/promoters';
import { PROMOTERS_LIST_PAGE_SIZE } from '@/modules/promoters/shared/promoters-table-pagination';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AccessDenied } from '../../../components/ui/access-denied';
import { useAccessControl } from '../../../hooks/useAccessControl';

const promotersSearchSchema = z.object({
  page: z.coerce.number().default(1),
  limit: z.coerce.number().default(PROMOTERS_LIST_PAGE_SIZE),
  search: z.string().optional(),
  status: z.enum(['active', 'deactivated']).optional(),
  game: z.string().optional(),
  date: z.string().optional(),
  entity: z.enum(['INDIVIDUAL', 'BUSINESS']).optional(),
});

export const Route = createFileRoute('/dashboard/promoters/')({
  validateSearch: promotersSearchSchema,
  component: PromotersPage,
});

function PromotersPage() {
  const { canAccessPromoterProfile } = useAccessControl();

  if (!canAccessPromoterProfile) {
    return <AccessDenied />;
  }

  return <PromotersModule />;
}
